import React, { useMemo } from "react";
import useSeo from "../seo/useSeo";
import useJsonLd from "../seo/useJsonLd";
import ImagesToPdf from "../components/ImagesToPdf";

export default function JpgToPdfPage() {
  useSeo({
    title: "JPG en PDF – Convertir des images en PDF A4 | pdf-convert.fr",
    description:
      "Transformez une ou plusieurs images en PDF A4. Résultat optimisé, zoom maximal, conversion locale et gratuite.",
    canonical: "https://pdf-convert.fr/jpg-pdf",
  });

  // Breadcrumb
  const breadcrumbJsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Accueil",
          item: "https://pdf-convert.fr/home",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Conversion",
          item: "https://pdf-convert.fr/conversion",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "JPG en PDF",
          item: "https://pdf-convert.fr/jpg-pdf",
        },
      ],
    }),
    []
  );

  useJsonLd("breadcrumb-jpg-pdf", breadcrumbJsonLd);

  // FAQ items
  const faqItems = useMemo(
    () => [
      {
        q: "Comment convertir des images en PDF ?",
        a: "Sélectionnez une ou plusieurs images, puis générez le PDF. Vous pourrez télécharger le document immédiatement.",
      },
      {
        q: "Le PDF est-il au format A4 ?",
        a: "Oui, le document est généré en A4. Les images sont ajustées pour remplir la page au maximum sans déformation.",
      },
      {
        q: "Mes images sont-elles envoyées sur un serveur ?",
        a: "Non. La conversion se fait localement dans votre navigateur, sans upload.",
      },
    ],
    []
  );

  // FAQ JSON-LD
  const faqJsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqItems.map((it) => ({
        "@type": "Question",
        name: it.q,
        acceptedAnswer: { "@type": "Answer", text: it.a },
      })),
    }),
    [faqItems]
  );

  useJsonLd("faq-jsonld-jpg-pdf", faqJsonLd);

  return (
    <main style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
      <h1>JPG / PNG → PDF</h1>
      <p style={{ textAlign: "center", color: "#666" }}>
        Convertissez des images en PDF A4, optimisé. Aucun envoi, tout se fait
        dans votre navigateur.
      </p>

      <ImagesToPdf />
    </main>
  );
}
